/* global DEBUG */

export function determineLocale(initialLocale, whiteLabelSettings, fallbackNavigatorLanguage) {
  let locale = initialLocale !== undefined ? initialLocale : fallbackNavigatorLanguage.slice(0, 2);

  if (typeof whiteLabelSettings !== 'undefined' && whiteLabelSettings.languages?.length) {
    if (!whiteLabelSettings.languages.includes(locale)) {
      locale = whiteLabelSettings.languages[0];
    }
  }
  return locale;
}

let locale = determineLocale(
  globalThis.globalLocale,
  globalThis.whiteLabelSettings,
  navigator.language || 'en'
);

globalThis.globalLocale = locale;

export default {
  debug: DEBUG,
  locale,
  whiteLabelSettings: globalThis.whiteLabelSettings,
};
